import { render, staticRenderFns } from "./auth-redirect.vue?vue&type=template&id=0910ce88&scoped=true"
import script from "./auth-redirect.vue?vue&type=script&lang=js"
export * from "./auth-redirect.vue?vue&type=script&lang=js"
import style0 from "./auth-redirect.vue?vue&type=style&index=0&id=0910ce88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0910ce88",
  null
  
)

export default component.exports